<template lang='pug'>
div
  .articleWithThumbnail-empty
    span.color--black30 目前無查核報告
  //- PopupContentContactForm(v-if="popupContactForm" @closePopup="popupContactForm = !popupContactForm"  @isSuccess="isSuccess" @isError="isError")
  //- PopupContentText(v-if="popupContentText" @closePopup="popupContentText = false" :text="text")
</template>

<script>
import PopupContentContactForm from '@/components/popup/popup_content_contact_form.vue'
import PopupContentText from '@/components/popup/popup_content_text.vue'
import { login } from '@/plugins/login.js'

export default {
  components: {
    PopupContentContactForm,
    PopupContentText
  },
  data() {
    return {
      text: [],
      popupContactForm: false,
      popupContentText: false,
      identity: localStorage.getItem(this.$store.state.storageKeys.identity)
    }
  },
  methods: {
    togglePopupContactForm() {
      if (!localStorage.getItem(this.$store.state.storageKeys.token))
        login(this.$store.state)
      else this.popupContactForm = !this.popupContactForm
    },
    isSuccess() {
      this.text=['表單已送出，我們會盡快與您聯繫，感謝您的來信。']
      this.popupContentText = true
    },
    isError() {
      this.text=['發生錯誤，請稍後再試']
      this.popupContentText = true
    }
  }
  
}
</script>